<template>
  <div class="mb-3 timeline-block" :class="darkMode">
    <span class="timeline-step" style="width: 41px;" :class="darkMode ? 'bg-dark' : ''">
      <!--
      <i class="ni text-gradient" :class="`ni-${icon} text-${color}`"></i>
      -->
      <img :style="styleImg(true)" :src="imgUrl" alt="photo" @error="handleImageError" v-if="imgUrl && imgUrl !== ''" />
      <img :style="styleImg(true)" :src="fallbackImgUrl" alt="photo" @error="handleFallbackError" v-else-if="fallbackImgUrl && fallbackImgUrl !== ''" />
      <img :style="styleImg()" :src="imgDef" alt="photo" v-else/>
    </span>
    <div class="timeline-content" style="top: -14px;">
      <h6
        class="mb-0 text-xs font-weight-bold"
        :class="darkMode ? 'text-white' : 'text-dark'">
        {{ title }}
      </h6>
      <p class="mt-1 mb-0 text-xxs text-secondary font-weight-bold">
        <b>Timestamp : </b>{{ moment(dateTime).format("ddd MMM DD, YYYY [at] HH:mm a") }}
      </p>
      <p v-if="description" class="mt-3 mb-2 text-sm">
        {{ description }}
      </p>
      <span
        v-for="(badge, index) of badges"
        :key="index"
        style="font-size : 0.55em;"
        class="badge badge-sm me-1"
        :class="`bg-gradient-${color}`"
      >
        {{ badeName(badge) }}
      </span>
      <span>
        <router-link
          v-if="url.active"
          class="text-secondary font-weight-bold text-xs"
          data-toggle="tooltip"
          data-original-title="View Pensioner"
          target="_blank"
          :to="{name:'View Pensioner' , params: {id:userId}}">
          <i class="fa fa-eye"></i> View
        </router-link>
      </span>
    </div>
  </div>
</template>
<script>
import imgDef from "@/assets/img/team-5.png";
import moment from "moment";

export default {
  name: "UpdateBeneficiariesList",
  props: {
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    userId: 
    {
      type: String,
      default:"",
    },
    title: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
      default: () => [],
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    imgUrl : {
      type: String,
      default : imgDef
    },
    fallbackImgUrl : {
      type: String,
      default : ''
    },
    url : {
      type : Object,
      default : {
        active : true,
        path : null
      }
    }
  },
  created(){
    this.moment = moment;
  },

  methods : 
  {
     handleImageError(event) {
       const failedSrc = event.target.src;
       // If primary image failed and fallback exists and is different, try fallback
       if (this.fallbackImgUrl && this.fallbackImgUrl !== '' && failedSrc !== this.fallbackImgUrl && failedSrc !== this.imgDef) {
         event.target.src = this.fallbackImgUrl;
       } else {
         // Final fallback to default image
         event.target.src = this.imgDef;
       }
     },

     handleFallbackError(event) {
       // Fallback image also failed, use default
       event.target.src = this.imgDef;
     },

     styleImg(border=false)
     { 
       var addborder = (border===true)? 'border : 2px solid #CCC' : '';

       return 'width:41px;height:41px;border-radius: 50% !important;'+addborder;
     },

     badeName(data)
     {  
        let response = '';

        if(data==null)
        {
           response = 'Suleija';
        }
        else
        {
           if(data.name!==undefined)
           {
            response = data.name;
           }
           else
           {
             response = data;
           }
        }

        return response;
     }
  },
  data(){
      return {
        imgDef
      }
  }
};
</script>
